<ng-container #View_Game>
  @if (!loaded) {
    <div class="loader-holder">
      <svg class="loader-icon">
        <use [attr.xlink:href]="svgSetIcon('loading')"></use>
      </svg>
    </div>
  }
</ng-container>

<ng-container #View_Error>
  @if (!loaded) {
    <div class="loader-holder">
      <svg class="loader-icon">
        <use [attr.xlink:href]="svgSetIcon('loading')"></use>
      </svg>
    </div>
  }
</ng-container>
